const dept_management_en = {
  edit_dept_info:'Edit department information',
  empty_name:'Please enter department name',
  empty_full_name:'Please enter the full name of the Department',
  empty_super_name:'Please select superior name',
  del_dept:'Delete department',
  empty_description: 'Please enter dept description'
}

export default dept_management_en



// WEBPACK FOOTER //
// ./src/common/lang/dept_management/dept_management_en.js